import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {t} from '../../../services/i18nHandler';

function HeaderAccordionMenu({title, data}) {
  const [showSubmenu, setShowSubmenu] = useState(false);

  return (
    <div className={`info-nav_accordion-item ${showSubmenu ? 'active' : ''}`}>
      <div
        role="button"
        className="info-nav_accordion-title"
        onClick={() => setShowSubmenu(!showSubmenu)}
      >
        {t(title)}
        <span className="info-nav_accordion-item-arrow" />
      </div>
      {showSubmenu && (
        <div className="info-nav_accordion-content">
          {data.map(({link, title: _title, download}, index) => {
            if (download) {
              return (
                <a href={link} className="info-nav_link" download key={index} target="_blank">
                  {t(_title)}
                </a>
              );
            }
            return (
              <Link to={link} className="info-nav_link" key={index}>
                {t(_title)}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

HeaderAccordionMenu.defaultProps = {
  title: '',
  data: [],
};

HeaderAccordionMenu.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape()),
};

export default HeaderAccordionMenu;
